/**
 * Turns a display name into a kebab-case slug of at most `maxLength` characters, for the create
 * forms that fill the slug from the name. Trims leading hyphens before the cut and trailing
 * ones after it, so the slug uses the whole cap and never ends in a hyphen.
 */
export function slugify(value: string, maxLength: number): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+/, "")
    .slice(0, maxLength)
    .replace(/-+$/, "");
}
